module.exports = __webpack_public_path__ + "img/edit.1e68523f.svg";